export default "__VITE_ASSET__ITLN1Blv__"